export const validOddsQuery = {
  bool: {
    must: [
      {
        range: {
          oddsDecimal: {
            gt: 0,
          },
        },
      },
    ],
  },
};
